/**=========================================================
 * Module: fileselector.js
 =========================================================*/

 App.directive('fileSelector', function() {
    return {
      restrict: 'A',
      scope: {
        selectorOptions: '='
      },
      controller: function($scope, $element) {
        let $elem = $($element);

        

        let toggleSelection = function(id){
          if(id==='*'){
              let v = true
              if($scope.selectorOptions.files.allSelected){ v = false; }
              $scope.selectorOptions.files.forEach((file) => {
                  if($scope.selectorOptions.extensions && (','+$scope.selectorOptions.extensions+',').indexOf(','+file.extension+',') == -1) return;
                  file.selected = v;
              });
              $scope.selectorOptions.files.allSelected = v;
          } else if(id){
              let file = $scope.selectorOptions.files.find((file) => { return file.id === id });
              if($scope.selectorOptions.extensions && (','+$scope.selectorOptions.extensions+',').indexOf(','+file.extension+',') == -1) return;
              file.selected = !file.selected;
          }
          $scope.selectorOptions.files.isThereAnySelected = false;
          for(let i=0; i<$scope.selectorOptions.files.length; i++){
              if($scope.selectorOptions.files[i].selected){
                  $scope.selectorOptions.files.isThereAnySelected = true;
                  break;
              }
          }
        }

        $scope.defaultSet = false
        $scope.$watch('selectorOptions.files', function(){
          if($scope.selectorOptions.files && $scope.selectorOptions.files.length){
            if(!$scope.defaultSet){
              if($scope.selectorOptions.selectionDefault){
                toggleSelection('*');
              }
              $scope.defaultSet = true;
            }
          }
        });
        
        
        $elem.on('click', function($event) {
            if($event.target.attributes['file-selector-target']){
                  toggleSelection($event.target.attributes['file-selector-target'].value);
            }
        })
      }
    };
  });